import { ItemType } from './itemType';

// One of the five colour groupings an ItemType is badged with.
export type EntityCategory = 'holdings' | 'vehicles' | 'capital' | 'directory' | 'analysis';

/** Maps every ItemType to its badge colour category. */
export const ENTITY_CATEGORY: Record<ItemType, EntityCategory> = {
  [ItemType.Company]: 'holdings',
  [ItemType.Security]: 'holdings',
  [ItemType.Fund]: 'vehicles',
  [ItemType.FundGroup]: 'vehicles',
  [ItemType.Investor]: 'capital',
  [ItemType.Contact]: 'directory',
  [ItemType.MailingList]: 'directory',
  [ItemType.CustomField]: 'directory',
  [ItemType.Forecast]: 'analysis',
  [ItemType.Report]: 'analysis',
};

/** Maps every ItemType to its singular uppercase entity-badge label. */
export const ENTITY_BADGE_LABEL: Record<ItemType, string> = {
  [ItemType.Company]: 'COMPANY',
  [ItemType.Security]: 'SECURITY',
  [ItemType.Fund]: 'FUND',
  [ItemType.FundGroup]: 'FUND GRP',
  [ItemType.Investor]: 'INVESTOR',
  [ItemType.Contact]: 'CONTACT',
  [ItemType.MailingList]: 'MAIL LIST',
  [ItemType.CustomField]: 'CUST FLD',
  [ItemType.Forecast]: 'FORECAST',
  [ItemType.Report]: 'REPORT',
};
